import { render, staticRenderFns } from "./ModalEditUser.vue?vue&type=template&id=3873b890&"
import script from "./ModalEditUser.vue?vue&type=script&lang=js&"
export * from "./ModalEditUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports